class TopicConfiguration {
    constructor() {
        this.is_randomized = false;
    }
}

export default TopicConfiguration;
